// Globals
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { changePassword } from '../../feature/actionCreators';
import { adminProfileSelector } from '../../feature/selectors';

// Components
import { ChangePasswordForm } from '../../components';
import { showSuccessToast, useForm } from '@/components';

// Helpers
import { TChangePasswordFieldsNamesValues } from '../../helpers/types';
import ChangePasswordDTO from '../../dtos/ChangePasswordDTO';

const ChangePasswordContainer = () => {
  const dispatch = useAppDispatch();
  const { isLoading } = useAppState(adminProfileSelector);
  const { t } = useTranslation(['profile']);
  const [form] = useForm();

  const handleSubmit = useCallback(async (values: TChangePasswordFieldsNamesValues) => {
    const changePasswordDto = new ChangePasswordDTO(values);
    await dispatch(changePassword(changePasswordDto)).unwrap();
    form.resetFields();
    showSuccessToast({ message: t('profile_data_saved') });
  }, []);

  return <ChangePasswordForm handleSubmit={handleSubmit} isLoading={isLoading} formInstance={form} />;
};

export default ChangePasswordContainer;
